import React from "react";
import { JobFilterContext, JobFilterContextType } from "./JobFilterContext";

export const useJobFilterContext = (): JobFilterContextType => {
    const context = React.useContext(JobFilterContext);
    return context;
};

export function withJobFilter<T extends JobFilterContextType = JobFilterContextType>(
    WrappedComponent: React.ComponentType<T>,
) {
    const ComponentWithJobFilterProps = (props: Omit<T, keyof JobFilterContextType>) => {
        const baseProps = useJobFilterContext();
        return <WrappedComponent {...(props as T)} {...baseProps} />;
    };

    return ComponentWithJobFilterProps;
}
